import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

const resources = {
  en: {
    translation: {
      register: 'Register',
      email: 'Email',
      phone: 'Phone Number',
      username: 'Username (optional)',
      usernameOptional: 'Leave blank to use email/phone as username',
      password: 'Password',
      confirmPassword: 'Confirm Password',
      notificationPreferences: 'Notification Preferences',
      emailNotifications: 'Receive email notifications',
      smsNotifications: 'Receive SMS notifications',
      marketingPreferences: 'Marketing Preferences',
      marketingEmails: 'Receive marketing emails',
      marketingSms: 'Receive marketing SMS',
      savePreferences: 'Save Preferences',
      passwordsDoNotMatch: 'Passwords do not match',
      registrationFailed: 'Registration failed. Please try again.',
      registrationSuccess: 'Registration successful! Please log in.',
      verifyEmail: 'Verify Your Email',
      verifyPhone: 'Verify Your Phone',
      verificationCode: 'Verification Code',
      verificationCodeSentEmail: 'Please enter the 6-digit verification code sent to your email.',
      verificationCodeSentPhone: 'Please enter the 6-digit verification code sent to your phone.',
      verify: 'Verify',
      verificationFailed: 'Verification failed. Please try again.',
      emailRegistration: 'Register with Email',
      phoneRegistration: 'Register with Phone',
      manageConsent: '(Manage Consent)',
      smsConsentManagement: 'SMS Consent Management',
      emailConsentManagement: 'Email Consent Management',
      smsConsentDescription: 'Manage your SMS notification preferences. You can opt in or out of different types of SMS notifications at any time.',
      emailConsentDescription: 'Manage your email notification preferences. You can opt in or out of different types of email notifications at any time.',
      preferencesUpdated: 'Your preferences have been updated successfully.',
      updateFailed: 'Failed to update preferences. Please try again.',
      smsOptOutInfo: 'To opt out of SMS messages at any time, simply reply "STOP" to any message you receive from us.',
      emailOptOutInfo: 'To opt out of email messages at any time, simply reply "STOP" to any email you receive from us.'
    }
  },
  ru: {
    translation: {
      register: 'Регистрация',
      email: 'Электронная почта',
      phone: 'Номер телефона',
      username: 'Имя пользователя (необязательно)',
      usernameOptional: 'Оставьте пустым, чтобы использовать email/телефон в качестве имени пользователя',
      password: 'Пароль',
      confirmPassword: 'Подтвердите пароль',
      notificationPreferences: 'Настройки уведомлений',
      emailNotifications: 'Получать уведомления по электронной почте',
      smsNotifications: 'Получать SMS уведомления',
      marketingPreferences: 'Маркетинговые предпочтения',
      marketingEmails: 'Получать маркетинговые письма',
      marketingSms: 'Получать маркетинговые SMS',
      savePreferences: 'Сохранить настройки',
      passwordsDoNotMatch: 'Пароли не совпадают',
      registrationFailed: 'Регистрация не удалась. Пожалуйста, попробуйте снова.',
      registrationSuccess: 'Регистрация успешна! Пожалуйста, войдите.',
      verifyEmail: 'Подтвердите вашу электронную почту',
      verifyPhone: 'Подтвердите ваш телефон',
      verificationCode: 'Код подтверждения',
      verificationCodeSentEmail: 'Пожалуйста, введите 6-значный код подтверждения, отправленный на вашу электронную почту.',
      verificationCodeSentPhone: 'Пожалуйста, введите 6-значный код подтверждения, отправленный на ваш телефон.',
      verify: 'Подтвердить',
      verificationFailed: 'Подтверждение не удалось. Пожалуйста, попробуйте снова.',
      emailRegistration: 'Регистрация с Email',
      phoneRegistration: 'Регистрация с телефоном',
      manageConsent: '(Управление согласием)',
      smsConsentManagement: 'Управление согласием на SMS',
      emailConsentManagement: 'Управление согласием на Email',
      smsConsentDescription: 'Управляйте настройками SMS уведомлений. Вы можете в любое время включить или отключить различные типы SMS уведомлений.',
      emailConsentDescription: 'Управляйте настройками уведомлений по электронной почте. Вы можете в любое время включить или отключить различные типы уведомлений по электронной почте.',
      preferencesUpdated: 'Ваши настройки успешно обновлены.',
      updateFailed: 'Не удалось обновить настройки. Пожалуйста, попробуйте снова.',
      smsOptOutInfo: 'Чтобы отказаться от SMS сообщений в любое время, просто ответьте "STOP" на любое сообщение, которое вы получили от нас.',
      emailOptOutInfo: 'Чтобы отказаться от сообщений по электронной почте в любое время, просто ответьте "STOP" на любое письмо, которое вы получили от нас.'
    }
  },
  uz: {
    translation: {
      register: 'Ro\'yxatdan o\'tish',
      email: 'Elektron pochta',
      phone: 'Telefon raqami',
      username: 'Foydalanuvchi nomi (ixtiyoriy)',
      usernameOptional: 'Bo\'sh qoldiring, email/telefonni foydalanuvchi nomi sifatida ishlatish uchun',
      password: 'Parol',
      confirmPassword: 'Parolni tasdiqlang',
      notificationPreferences: 'Bildirishnoma sozlamalari',
      emailNotifications: 'Elektron pochta orqali bildirishnomalarni olish',
      smsNotifications: 'SMS bildirishnomalarni olish',
      marketingPreferences: 'Marketing sozlamalari',
      marketingEmails: 'Marketing xatlarini olish',
      marketingSms: 'Marketing SMS olish',
      savePreferences: 'Sozlamalarni saqlash',
      passwordsDoNotMatch: 'Parollar mos kelmaydi',
      registrationFailed: 'Ro\'yxatdan o\'tish muvaffaqiyatsiz. Iltimos, qayta urinib ko\'ring.',
      registrationSuccess: 'Ro\'yxatdan o\'tish muvaffaqiyatli! Iltimos, tizimga kiring.',
      verifyEmail: 'Elektron pochtangizni tasdiqlang',
      verifyPhone: 'Telefoningizni tasdiqlang',
      verificationCode: 'Tasdiqlash kodi',
      verificationCodeSentEmail: 'Iltimos, elektron pochtangizga yuborilgan 6 raqamli tasdiqlash kodini kiriting.',
      verificationCodeSentPhone: 'Iltimos, telefoningizga yuborilgan 6 raqamli tasdiqlash kodini kiriting.',
      verify: 'Tasdiqlash',
      verificationFailed: 'Tasdiqlash muvaffaqiyatsiz. Iltimos, qayta urinib ko\'ring.',
      emailRegistration: 'Email bilan ro\'yxatdan o\'tish',
      phoneRegistration: 'Telefon bilan ro\'yxatdan o\'tish',
      manageConsent: '(Rozilikni boshqarish)',
      smsConsentManagement: 'SMS rozilik boshqaruvi',
      emailConsentManagement: 'Email rozilik boshqaruvi',
      smsConsentDescription: 'SMS bildirishnoma sozlamalarini boshqaring. Har qanday vaqtda turli xil SMS bildirishnoma turlarini yoqish yoki o\'chirish mumkin.',
      emailConsentDescription: 'Elektron pochta bildirishnoma sozlamalarini boshqaring. Har qanday vaqtda turli xil elektron pochta bildirishnoma turlarini yoqish yoki o\'chirish mumkin.',
      preferencesUpdated: 'Sozlamalar muvaffaqiyatli yangilandi.',
      updateFailed: 'Sozlamalarni yangilash muvaffaqiyatsiz. Iltimos, qayta urinib ko\'ring.',
      smsOptOutInfo: 'Har qanday vaqtda SMS xabarlaridan voz kechish uchun bizdan olgan har qanday xabarga "STOP" javobini yuboring.',
      emailOptOutInfo: 'Har qanday vaqtda elektron pochta xabarlaridan voz kechish uchun bizdan olgan har qanday xatga "STOP" javobini yuboring.'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('i18nextLng') || 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru', 'uz'],
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n; 